<template>
    <div>
        <div class="row">
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <div class="form-group">
                    <label class="generic-label" for="txtOwnerName">Owner Name</label>
                    <input id="txtOwnerName" name="txtOwnerName" maxlength="25" type="text" placeholder="Owner Name" class="form-control generic-input" v-model="call.OwnerName" :readonly="readOnly">
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12">
                <div class="form-group">
                    <label class="generic-label" for="txtOwnerPhone">Owner Phone #</label>
                    <input id="txtOwnerPhone" name="txtOwnerPhone" maxlength="15" type="tel" placeholder="Owner Phone #" class="form-control generic-input" v-model="call.OwnerPhone" :readonly="readOnly">
                </div>
            </div>

            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12"></div>
            <div class="col-lg-3 col-md-3 col-sm-3 col-xs-12"></div>
        </div>
    </div>
</template>

<style lang="scss" scoped>

</style>

<script>
    export default {

        props: {
            call: Object,
            readOnly: Boolean,
        },

    }
</script>

